import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import { INITIAL_FORM, Purchase } from "../../../models/Purchase";
import { addPurchase, setModalAddPurchaseStatus } from "../../../store/PurchaseSlice";
import "./modal-add-purchases.scss";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { ShoppingCart } from "lucide-react";
import { FunctionComponent, useEffect, useState } from "react";

import { Modal, FormField } from "../../ui";

const ModalAddPurchase: FunctionComponent = () => {

    const dispatch      = useAppDispatch();
    const modalStatus   = useAppSelector((state) => state.purchase.modalAddPurchaseStatus);
    const assetsList    = useAppSelector((state) => state.assets.assets);
    const suppliersList = useAppSelector((state) => state.supplier.suppliersOrganization);
    const clientsList   = useAppSelector((state) => state.user.clientList);

    const [form, setForm]                   = useState<Purchase>(INITIAL_FORM);
    const [selectedAsset, setSelectedAsset] = useState<any | null>();

    const handleChange = (field: keyof Purchase, value: string | Date | null) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const isFormValid = () =>
        form.target_supplier_id &&
        form.origin_client_id &&
        form.asset_id_origin &&
        form.asset_id_target &&
        form.quotation_real &&
        form.quotation_organization &&
        form.value &&
        form.createdAt;

    const submit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!isFormValid()) return;

        dispatch(addPurchase({
            target_supplier_id:     Number(form.target_supplier_id),
            origin_client_id:       Number(form.origin_client_id),
            asset_id_origin:        Number(form.asset_id_origin),
            asset_id_target:        Number(form.asset_id_target),
            quotation_real:         form.quotation_real,
            quotation_organization: form.quotation_organization,
            value:                  form.value,
            createdAt:              form.createdAt,
        }));
    };

    useEffect(() => {
        if (!modalStatus) setForm(INITIAL_FORM);
    }, [modalStatus]);

    const close = () => dispatch(setModalAddPurchaseStatus(!modalStatus));

    const handleAssetChange = (val: number) => {
        if (assetsList) {
            const asset = assetsList.find((a: any) => a.id === val);
            setSelectedAsset(asset ?? null);
        }
    };

    return (
        <Modal
            open
            onClose={close}
            icon={ShoppingCart}
            title="Adicionar swap"
            subtitle="novo swap"
            maxWidth={680}
            className="modal-add-purchase"
            footer={
                <>
                    <button type="button" className="btn-pill ghost" onClick={close}>Cancelar</button>
                    <button
                        type="submit"
                        form="modal-add-purchase-form"
                        className="btn-pill primary"
                        disabled={!isFormValid()}
                    >
                        <ShoppingCart size={16} /> Adicionar swap
                    </button>
                </>
            }
        >
            <form id="modal-add-purchase-form" onSubmit={submit}>
                <div className="form-row">
                    <FormField label="Fornecedor" htmlFor="supplier">
                        <select id="supplier" value={form.target_supplier_id}
                            onChange={(e) => handleChange("target_supplier_id", e.target.value)}>
                            <option value="">Selecione o fornecedor</option>
                            {suppliersList?.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
                        </select>
                    </FormField>
                    <FormField label="Cliente" htmlFor="client">
                        <select id="client" value={form.origin_client_id}
                            onChange={(e) => handleChange("origin_client_id", e.target.value)}>
                            <option value="">Selecione o cliente</option>
                            {clientsList?.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                        </select>
                    </FormField>
                </div>

                <div className="form-row">
                    <FormField label="Moeda paga" htmlFor="asset_origin">
                        <select id="asset_origin" value={form.asset_id_origin}
                            onChange={(e) => {
                                handleChange("asset_id_origin", e.target.value);
                                handleAssetChange(Number(e.target.value));
                            }}>
                            <option value="">Selecione a moeda</option>
                            {assetsList?.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                    </FormField>
                    <FormField label="Moeda recebida" htmlFor="asset_target">
                        <select id="asset_target" value={form.asset_id_target}
                            onChange={(e) => handleChange("asset_id_target", e.target.value)}>
                            <option value="">Selecione a moeda</option>
                            {assetsList?.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                    </FormField>
                </div>

                <div className="form-row">
                    <FormField label="Quotação Cliente" htmlFor="quotation_real">
                        <input id="quotation_real" type="number" step="0.0001" placeholder="0,0000"
                            value={form.quotation_organization}
                            onChange={(e) => handleChange("quotation_organization", e.target.value)} />
                    </FormField>
                    <FormField label="Quotação Fornecedor" htmlFor="quotation_org">
                        <input id="quotation_org" type="number" step="0.0001" placeholder="0,0000"
                            value={form.quotation_real}
                            onChange={(e) => handleChange("quotation_real", e.target.value)} />
                    </FormField>
                </div>

                <div className="form-row">
                    <FormField
                        label={`Valor pago ${selectedAsset ? `(${selectedAsset.symbol})` : ""}`}
                        htmlFor="value"
                    >
                        <input id="value" type="number" step="0.01" placeholder="0,00"
                            value={form.value} onChange={(e) => handleChange("value", e.target.value)} />
                    </FormField>
                    <FormField label="Data da compra" htmlFor="purchase_date">
                        <DatePicker
                            id="purchase_date"
                            selected={form.createdAt}
                            onChange={(date: any) => handleChange("createdAt", date)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Selecione a data"
                            maxDate={new Date()}
                        />
                    </FormField>
                </div>
            </form>
        </Modal>
    );
};

export default ModalAddPurchase;
